export default {
  vendorName: {
    type: 'string',
    required: true,
  },
  country: {
    type: 'string',
    required: true,
  },
  owner: {
    type: 'string',
    required: true,
  },
  taxRegistrationNumber: {
    type: 'string',
    maxSize: 12,
    required: {
      value: true,
      when: {
        $country: {
          in: ['Belarus', 'Poland'],
        },
      },
    },
  },
  costCenterId: {
    type: 'string',
    required: true,
  },
  isCompliant: {
    type: 'boolean',
    required: true,
  },
  isDataProcessor: {
    type: 'boolean',
    required: true,
  },
  isAutoApproved: {
    type: 'boolean',
    required: true,
  },
  purpose: {
    type: 'string',
    required: true,
  },
  phoneNumber: {
    type: 'string',
    required: false,
    phone: {
      value: true,
      message: 'Please enter phone number in format xxxxxxxxxxxx, max. 15 characters',
    },
  },
  email: {
    type: 'string',
    email: false,
    required: false,
  },
  contacts: {
    type: 'array',
    required: false,
    maxSize: 3,
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        name: {
          type: 'string',
          required: true,
        },
        phoneNumber: {
          type: 'string',
          required: true,
          phone: {
            value: true,
            message: 'Please enter phone number in format xxxxxxxxxxxx, max. 15 characters',
          },
        },
        email: {
          type: 'string',
          email: true,
          required: false,
        },
      },
    },
  },
};
